module.exports = __webpack_public_path__ + "static/media/so-home__windmill.e2dae157.svg";